{
  "name": "stadtland.funk",
  "version": "2.2.0",
  "main": "index.ts",
  "scripts": {
    "start": "cross-env NODE_ENV=${NODE_ENV:-local} expo start",
    "test": "jest",
    "test:e2e": "playwright test -c e2e/playwright.config.ts",
    "test:e2e:rss-server": "node scripts/rssFeedServerProcess.cjs",
    "test:e2e:ui": "playwright test -c e2e/playwright.config.ts --ui",
    "test:e2e:install": "playwright install chromium",
    "test:e2e:typecheck": "tsc --noemit -p e2e/tsconfig.json",
    "ios": "cross-env NODE_ENV=${NODE_ENV:-local} expo run:ios",
    "ios:device": "cross-env NODE_ENV=${NODE_ENV:-local} expo run:ios --device",
    "native:setup": "cross-env NODE_ENV=${NODE_ENV:-local} expo prebuild --clean",
    "ios:prebuild": "cross-env NODE_ENV=${NODE_ENV:-local} expo prebuild --clean --platform ios",
    "ios:archive": "cross-env NODE_ENV=${NODE_ENV:-local} expo prebuild --clean --platform ios && xcodebuild -workspace ios/StadtLandFunk.xcworkspace -scheme StadtLandFunk -configuration Release -archivePath ios/StadtLandFunk.xcarchive CODE_SIGN_IDENTITY= CODE_SIGNING_REQUIRED=NO CODE_SIGNING_ALLOWED=NO archive",
    "android": "cross-env NODE_ENV=${NODE_ENV:-local} expo run:android",
    "android:build:apk:unsigned": "cross-env NODE_ENV=${NODE_ENV:-local} expo prebuild --clean --platform android && cd android && ./gradlew assembleRelease",
    "android:build:aab:unsigned": "cross-env NODE_ENV=${NODE_ENV:-local} expo prebuild --clean --platform android && cd android && ./gradlew bundleRelease",
    "web": "cross-env NODE_ENV=${NODE_ENV:-local} expo start --web",
    "preview": "cross-env NODE_ENV=${NODE_ENV:-local} expo start --web --no-dev --minify",
    "web:build": "npm run web:build:${NODE_ENV:-dev}",
    "web:build:dev": "env-cmd -f '.env.dev' expo export --platform web --clear --dump-sourcemap",
    "web:build:stage": "env-cmd -f '.env.stage' expo export --platform web --clear --dump-sourcemap",
    "web:build:production": "env-cmd -f '.env.production' expo export --platform web --clear --dump-sourcemap",
    "prepare": "husky",
    "preinstall": "npx only-allow pnpm",
    "ts:check": "tsc --noemit --project tsconfig.test.json",
    "lint": "oxlint index.ts App.tsx src e2e && pnpm format:check && pnpm ts:check",
    "lint:fix": "oxlint --fix index.ts App.tsx src e2e && oxfmt \"{src,e2e}/**/*.{js,ts,tsx,css,scss,less}\"",
    "format": "oxfmt \"{src,e2e}/**/*.{js,ts,tsx,css,scss,less}\"",
    "format:check": "oxfmt --check \"{src,e2e}/**/*.{js,ts,tsx,css,scss,less}\"",
    "check:project": "expo install --check && expo-doctor",
    "analyze:dependencies:graph": "depcruise --exclude \"^(coverage|test|node_modules|embedded)\" --output-type dot index.ts App.tsx src | dot -T svg | depcruise-wrap-stream-in-html > dependency-graph.html",
    "analyze:dependencies:report": "depcruise --exclude \"^(coverage|test|node_modules|embedded)\" --validate --output-type err-html -f dependency-report.html index.ts App.tsx src",
    "analyze:dependencies:check": "depcruise --exclude \"^(coverage|test|node_modules|embedded)\" --validate index.ts App.tsx src",
    "analyze:bundle": "EXPO_UNSTABLE_ATLAS=true || set EXPO_UNSTABLE_ATLAS=true&& expo export && expo-atlas .expo/atlas.jsonl"
  },
  "engines": {
    "node": ">=22",
    "pnpm": ">=10"
  },
  "expo": {
    "doctor": {
      "reactNativeDirectoryCheck": {
        "exclude": [
          "@DigitaleDoerfer/digitale-doerfer-api"
        ]
      }
    }
  },
  "dependencies": {
    "@DigitaleDoerfer/digitale-doerfer-api": "2.2.0-SNAPSHOT-20261001-130746-master-b8433b39-1790860579671",
    "@expo-google-fonts/montserrat": "0.4.2",
    "@expo/dom-webview": "57.0.1",
    "@expo/metro-runtime": "57.0.16",
    "@expo/vector-icons": "15.1.1",
    "@gorhom/bottom-sheet": "5.2.14",
    "@hookform/resolvers": "5.7.1",
    "@legendapp/list": "3.3.3",
    "@material-symbols/svg-400": "0.44.12",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-community/netinfo": "12.0.1",
    "@react-navigation/bottom-tabs": "7.18.16",
    "@react-navigation/elements": "2.9.38",
    "@react-navigation/material-top-tabs": "7.6.15",
    "@react-navigation/native": "7.3.16",
    "@react-navigation/native-stack": "7.18.8",
    "@sentry/react-native": "7.11.0",
    "@tanstack/query-async-storage-persister": "5.101.4",
    "@tanstack/react-query": "5.101.4",
    "@tanstack/react-query-persist-client": "5.101.4",
    "dayjs": "1.11.21",
    "expo": "57.0.25",
    "expo-application": "57.0.3",
    "expo-asset": "57.0.18",
    "expo-auth-session": "57.0.13",
    "expo-build-properties": "57.0.22",
    "expo-clipboard": "57.0.2",
    "expo-device": "57.0.2",
    "expo-document-picker": "57.0.2",
    "expo-file-system": "57.0.7",
    "expo-font": "57.0.4",
    "expo-image": "57.0.5",
    "expo-image-manipulator": "57.0.20",
    "expo-image-picker": "57.0.20",
    "expo-linear-gradient": "57.0.2",
    "expo-linking": "57.0.11",
    "expo-location": "57.0.20",
    "expo-notifications": "57.0.21",
    "expo-splash-screen": "57.0.9",
    "expo-status-bar": "57.0.1",
    "expo-system-ui": "57.0.4",
    "expo-task-manager": "57.0.20",
    "expo-web-browser": "57.0.3",
    "i18next": "26.0.8",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "react-hook-form": "7.85.0",
    "react-i18next": "17.0.4",
    "react-native": "0.86.3",
    "react-native-awesome-slider": "2.9.0",
    "react-native-collapsible": "1.6.2",
    "react-native-edge-to-edge": "1.8.1",
    "react-native-gesture-handler": "2.32.0",
    "react-native-keyboard-controller": "1.21.9",
    "react-native-pager-view": "8.0.2",
    "react-native-paper": "5.15.3",
    "react-native-paper-dates": "0.23.16",
    "react-native-pkce-challenge": "6.2.0",
    "react-native-reanimated": "4.5.1",
    "react-native-reanimated-carousel": "4.0.3",
    "react-native-safe-area-context": "5.7.0",
    "react-native-screens": "4.26.2",
    "react-native-share": "12.3.1",
    "react-native-sortables": "1.10.0",
    "react-native-svg": "15.15.4",
    "react-native-web": "0.21.2",
    "react-native-webview": "13.16.1",
    "react-native-worklets": "0.10.1",
    "react-native-zoom-toolkit": "5.1.0",
    "use-debounce": "10.1.1",
    "zod": "4.4.3",
    "zustand": "5.0.14"
  },
  "devDependencies": {
    "@babel/core": "7.29.7",
    "@playwright/test": "1.62.1",
    "@tanstack/eslint-plugin-query": "5.99.0",
    "@testing-library/react-native": "13.3.3",
    "@types/color": "4.2.1",
    "@types/jest": "29.5.14",
    "@types/node": "25.9.5",
    "@types/react": "19.2.18",
    "cross-env": "10.1.0",
    "dependency-cruiser": "17.4.3",
    "env-cmd": "11.0.0",
    "eslint": "9.39.5",
    "eslint-plugin-depend": "1.5.0",
    "eslint-plugin-i18next": "6.1.5",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-react-native-a11y": "3.5.1",
    "eslint-plugin-react-refresh": "0.5.4",
    "expo-atlas": "0.4.3",
    "expo-doctor": "1.20.4",
    "husky": "9.1.7",
    "jest": "29.7.0",
    "jest-expo": "57.0.5",
    "jest-junit": "16.0.0",
    "oxfmt": "0.70.0",
    "oxlint": "1.85.0",
    "oxlint-tsgolint": "7.0.2003",
    "react-native-svg-transformer": "1.5.3",
    "ts-node": "10.9.2",
    "typescript": "6.0.3"
  },
  "private": true,
  "packageManager": "pnpm@10.33.0+sha512.10568bb4a6afb58c9eb3630da90cc9516417abebd3fabbe6739f0ae795728da1491e9db5a544c76ad8eb7570f5c4bb3d6c637b2cb41bfdcdb47fa823c8649319"
}
